import AddIcon from "@mui/icons-material/AddCircle";
import RemoveIcon from "@mui/icons-material/RemoveCircle";
import axios from "axios";
import { useContext } from "react";

import { PfaContext } from "../..";
import { useAuth } from "../../../../hooks/useAuth";

import PfaActionMenuItem from "./PfaActionMenuItem";

const PfaPublishAction = ({ file }) => {
  const { authToken, csrfToken } = useAuth();
  const { tableRef } = useContext(PfaContext);

  if (file.private || !file.approved) return null;

  const icon = file.published ? RemoveIcon : AddIcon;
  const label = file.published ? "Retract" : "Publish";

  const handleClick = () => {
    const status = JSON.stringify(!file.published);

    axios
      .put(
        `${import.meta.env.VITE_DJANGO_ENDPOINT}file/${file.file_id}/`,
        {
          published: status,
          approved: status,
        },
        {
          withCredentials: true,
          headers: {
            "X-CSRFToken": csrfToken,
            Authorization: `Token ${authToken}`,
          },
        },
      )
      .then((response) => {
        tableRef.current.onQueryChange();
      })
      .catch((error) => {
        console.error(error);
      });
  };

  return (
    <PfaActionMenuItem
      file={file}
      Icon={icon}
      label={label}
      onClick={handleClick}
    />
  );
};

export default PfaPublishAction;
